import React, { Component } from 'react'
import { muiWithStyles, MuiGrid } from '../../../ui/MaterialUIComponents';
import PageHeaderComponent from '../../../ui/PageHeaderComponent'
class TeacherTitleComponent extends Component {
  render() {
    const { i18n } = this.props
    return (
      <MuiGrid container xs={10} direction="row">
        <PageHeaderComponent {...this.props} title={i18n.teachers.title} subTitle={i18n.teachers.tabDescription} />
      </MuiGrid>
    )
  }
}

export default TeacherTitleComponent